import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b26fa9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-lt-x" }, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("会员中心")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("其他1")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("其他2")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("其他3")
const _hoisted_7 = { class: "header-rt-logo" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding-left":"15px"} }, null, -1))
const _hoisted_9 = { class: "el-dropdown-link" }
const _hoisted_10 = { style: {"color":"#ffffff"} }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("退出登录")

import { ref } from 'vue';
import { useRouter } from 'vue-router';

import { defineComponent } from 'vue';
import { shallowReactive } from 'vue';
import store from '@/store/index';
import { useStore } from '@/store/index';
import router from '@/router/index';
import tool from '@/utils/tool';
import { ArrowDown, Avatar } from '@element-plus/icons-vue';


export default /*#__PURE__*/_defineComponent({
  emits: ['on-tabs'],
  setup(__props, { emit }) {

const ustore = useStore();

var bindData = shallowReactive({
  loginMember:
    ustore.state.loginMember == undefined ? {} : ustore.state.loginMember,
});
if (ustore.state.loginMember == undefined) {
  store.dispatch('getMyInfo').then(
    (data) => {
      //成功
      bindData.loginMember = data.result;
    },
    (error) => {
      console.log('获取当前登录会员信息错误');
    }
  );
}



const tabs = ref([
  {
    title: '楼盘招商',
    name: 0,
    path: '/middleGround/invest',
  },
 {
    title: '营销推广',
    name: 1,
    path: '/middleGround/community',
  },
  {
    title: '人才招募',
    name: 2,
    path: '/middleGround/recruit',
  },
  {
    title: '会员资料',
    name: 3,
    path: '/middleGround/member',
  },
  {
    title: '我的',
    name: 4,
    path: '/middleGround/my',
  },
]);

const activeIndex = ref('1');
const activeName = ref(0);

const currPath = router.currentRoute.value.path;
const currIndex = tabs.value.findIndex((tab: any) => {
  return currPath.toLowerCase().startsWith(tab.path.toLowerCase());
});

if (currIndex >= 0) {
  activeName.value = tabs.value[currIndex].name;
}

const handleSelect = (key: string, keyPath: string[]) => {
  console.log(key, keyPath);
};
const handleTabsToggle = () => {
  emit('on-tabs', activeName.value);
};
const logoutEvent = () => {
  store.dispatch('memberLogout').then(
    (data) => {
      //成功
      router.push('/frontDesk/login');
    },
    (error) => {
      console.log(error.msg);
    }
  );
};
const handleToIndexEvent = () => {
  router.push('/frontDesk/index');
};

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_container, { class: "header-lt" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_image, {
              class: "header-lt-logo",
              src: require('@/assets/fd/logo_sqr.png'),
              onClick: handleToIndexEvent
            }, null, 8, ["src"]),
            _hoisted_2,
            _createVNode(_component_el_menu, {
              "default-active": activeIndex.value,
              class: "header-lt-select",
              mode: "vertical",
              onSelect: handleSelect
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_sub_menu, {
                  class: "header-lt-select-sub",
                  index: "1"
                }, {
                  title: _withCtx(() => [
                    _hoisted_3
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_menu_item, { index: "1-1" }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, { index: "1-2" }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, { index: "1-3" }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["default-active"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_container, { class: "header-rt" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_container, { class: "header-rt-tabs" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tabs, {
                  modelValue: activeName.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event)),
                  onTabClick: handleTabsToggle
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_tab_pane, {
                        key: item.name,
                        label: item.title,
                        name: item.name
                      }, null, 8, ["label", "name"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_7, [
              (_unref(tool).isNull(_unref(bindData).loginMember.avatarUrl))
                ? (_openBlock(), _createBlock(_component_el_icon, {
                    key: 0,
                    class: "fd-header-tp-box-avatar"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Avatar), {
                        color: "#015d87",
                        size: 30
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(tool).isNotNull(_unref(bindData).loginMember.avatarUrl))
                ? (_openBlock(), _createBlock(_component_el_image, {
                    key: 1,
                    class: "header-rt-logo-img",
                    src: _unref(bindData).loginMember.avatarUrl
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_8,
            _createVNode(_component_el_dropdown, null, {
              dropdown: _withCtx(() => [
                _createVNode(_component_el_dropdown_menu, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_dropdown_item, { onClick: logoutEvent }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(bindData).loginMember.name), 1),
                  _createVNode(_component_el_icon, {
                    class: "el-icon--right",
                    style: {"color":"#ffffff"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ArrowDown))
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})